import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../../../../core/services/language.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import {
  ActivateVehicleInfo,
  ConfirmActivateMemberPayload,
  CardByVehicleTypeInfo,
} from '../../../../../core/models/activate.model';
import { FormsModule } from '@angular/forms';
import { PssLoadingComponent } from "../../../../../tools/template/pss/pss-loading/pss-loading.component";
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { ApiMemberService } from '../../../../../core/services/api/Member/api-member';
import { ApiMemberCardService } from '../../../../../core/services/api/Member/api-member-card';
import { ApiActiveMemberService } from '../../../../../core/services/api/Member/api-active-member';

@Component({
  selector: 'app-activate-member-card',
  imports: [
    CommonModule,
    FormsModule,
    PssLoadingComponent,
  ],
  templateUrl: './activate-member-card.component.html',
  styleUrl: './activate-member-card.component.css',
})
export class ActivateMemberCardComponent implements OnInit {
  uid: string = '';
  token: string = '';
  currentLang: 'TH' | 'EN' = 'TH';
  activateMemberCardList: ActivateVehicleInfo[] = [
    // {
    //   code: 'ABC123',
    //   startDate: new Date(),
    //   endDate: new Date(),
    //   phone: '0123456789',
    //   vehicleId: 1,
    //   vehicleName: 'Car',
    //   siteId: 1,
    //   siteName: 'Site 1',
    //   vehicleLimit: 1,
    //   logo: '',
    // }
  ];
  isLoading: boolean = false; // สถานะการโหลดข้อมูล7
  selectMemberCardInfo: ActivateVehicleInfo | null = null;
  cardByVehicleTypeInfo: CardByVehicleTypeInfo[] = [];
  // Plus Form
  isPlusChoseForm: string | null = null;
  previewUrl: string | ArrayBuffer | null = null;
  codeActivateMemberCard: string = '';

  isConfirmModal: boolean = false;
  showModal_option: boolean = false;

  isActivateMemberCardModal: boolean = false;
  isShowCardInfoModal: boolean = false;

  // Modal
  showPlusModal: boolean = false;
  showConfirmModal: boolean = false;

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''

  constructor(
    private languageService: LanguageService,
    private cookieService: CookieService,
    private router: Router,
    private apiActiveMemberService: ApiActiveMemberService,
    private apiMemberCardService: ApiMemberCardService,
    private toastCustomService: ToastCustomService
  ) {
    this.languageService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
    });
  }

  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') ||
      localStorage.getItem('line_uid') ||
      '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';
    setTimeout(() => {
      this.getActivateMemberCardList();
    }, 300);
  }



  /* ----------------------------------------------- Function ----------------------------------------------- */
  /* --- Style --- */
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }

  /* --- Function --- */
  onClickActivate(selectMemberCard: ActivateVehicleInfo) {
    this.selectMemberCardInfo = selectMemberCard;
    // this.router.navigate(['/activate-member-card-form'], {
    //     state: {
    //       code: this.selectMemberCardInfo?.code,
    //       startDate: this.selectMemberCardInfo?.startDate,
    //       endDate: this.selectMemberCardInfo?.endDate,
    //       siteId: this.selectMemberCardInfo?.siteId,
    //       vehicleLimit: this.selectMemberCardInfo?.vehicleLimit,
    //       vehicleId: this.selectMemberCardInfo?.vehicleId,
    //       vehicleName: this.selectMemberCardInfo?.vehicleName,
    //       siteName: this.selectMemberCardInfo?.siteName,
    //       cardCode: '',
    //     },
    //   });
    this.showModal_option = true;
  }

  onClickActivateMemberCard() {
    this.showModal_option = false;
    // console.log('id', this.selectMemberCardInfo);
    if (this.selectMemberCardInfo) {
      this.router.navigate(['/activate-member-card-form'], {
        state: {
          code: this.selectMemberCardInfo?.code,
          startDate: this.selectMemberCardInfo?.startDate,
          endDate: this.selectMemberCardInfo?.endDate,
          siteId: this.selectMemberCardInfo?.siteId,
          vehicleLimit: this.selectMemberCardInfo?.vehicleLimit,
          vehicleId: this.selectMemberCardInfo?.vehicleId,
          vehicleName: this.selectMemberCardInfo?.vehicleName,
          siteName: this.selectMemberCardInfo?.siteName,
          cardCode: '',
        },
      });
    } else {
      console.log('No Select Item');
    }
  }

  onClickActivateMemberCardRenewToForm(cardCode: string) {
    console.log('Card Code : ', cardCode);
    this.isShowCardInfoModal = false;
    if (this.selectMemberCardInfo) {
      this.router.navigate(['/activate-member-card-form'], {
        state: {
          code: this.selectMemberCardInfo?.code,
          startDate: this.selectMemberCardInfo?.startDate,
          endDate: this.selectMemberCardInfo?.endDate,
          siteId: this.selectMemberCardInfo?.siteId,
          vehicleLimit: this.selectMemberCardInfo?.vehicleLimit,
          vehicleId: this.selectMemberCardInfo?.vehicleId,
          vehicleName: this.selectMemberCardInfo?.vehicleName,
          siteName: this.selectMemberCardInfo?.siteName,
          cardCode: cardCode,
        },
      });
    } else {
      console.log('No Select Item');
    }
  }



  goback() {
    this.router.navigate(['/home']);
  }
  goToNavigate(url: string) {
    this.router.navigate([url]);
  }

  /*---- Plus Form ----*/
  onClickCodeActivateMemberCard() {
    // ตรวจสอบ
    if (this.codeActivateMemberCard === '') {
      this.showWarning(this.currentLang === 'TH' ? 'กรุณากรอกรหัส' : 'Please enter the code');
      return;
    }

    this.showConfirmModal = true;
  }
  onClickConfirmActivateMemberCard(result: boolean) {
    if (result) {
      this.updateActivateMemberCard({
        uid: this.uid,
        codeMember: this.codeActivateMemberCard,
      });
    }
    this.showConfirmModal = false;
  }

  // Image
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }
  // Reset
  resetPlusModalForm() {
    this.codeActivateMemberCard = '';
    this.previewUrl = null;
    this.isPlusChoseForm = null;
    this.showPlusModal = false;
  }

  /*---- Modal ----*/
  onCloseModalPlus() {
    // if ( !this.isPlusChoseForm ){
    //   this.showPlusModal = false;
    // }
    this.showPlusModal = false;
    this.isPlusChoseForm = null;
    //liff.scanCodeV2();
  }

  /*------------------------------------------------ API ------------------------------------------------ */
  getActivateMemberCardList() {
    this.isLoading = true;
    // console.log(this.token);
    this.apiActiveMemberService.getMyMemberActivate(this.uid, this.token).subscribe({
      next: (response: ActivateVehicleInfo[]) => {
        console.log('getMyMemberActivate', response);
        this.activateMemberCardList = response;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('โหลดบัตรสมาชิกล้มเหลว', err);
        this.isLoading = false;
      },
    });
  }
  updateActivateMemberCard(payload: ConfirmActivateMemberPayload) {
    this.isLoading = true
    console.log('token : ', this.token);
    this.apiActiveMemberService.updateMyMemberActivate(this.token, payload).subscribe({
      next: (response) => {
        this.isLoading = false
        console.log('updateActivateMemberCard', response);
        if (response.code === '000') {
          this.showSuccess(this.currentLang === 'TH' ? 'บันทึกสําเร็จ' : 'Save successfully');
          this.resetPlusModalForm();
          this.getActivateMemberCardList();
        } else {
          this.showError('ไม่พบรหัสที่กรอก');
        }
      },
      error: (err) => {
        this.isLoading = false
        console.error('บันทึกล้มเหลว', err);
        this.showError(this.currentLang === 'TH' ? 'บันทึกล้มเหลว' : 'Save failed');
      },
    });
  }
  onClickActivateMemberCardRenew() {
    this.showModal_option = false;
    if (this.selectMemberCardInfo) {
      this.isLoading = true;
      this.apiMemberCardService
        .getCardByVehicleTypeInfo(
          this.uid,
          this.selectMemberCardInfo.siteId,
          this.selectMemberCardInfo.vehicleId,
          this.selectMemberCardInfo.vehicleId,
          this.token
        )
        .subscribe({
          next: (response: CardByVehicleTypeInfo[]) => {
            console.log('CardByVehicleTypeInfo', response);
            this.cardByVehicleTypeInfo = response;
            this.isShowCardInfoModal = true;
            this.isLoading = false;
          },
          error: (err) => {
            console.error('โหลดบัตรสมาชิกล้มเหลว', err);
            this.isLoading = false;
          },
        });
    } else {
      console.log('No Select Item');
    }
  }
}
